import { postJSON } from 'common/services/api'
import { useMutation, useQueryClient } from 'react-query'
import {
  INSTANCE_QUERY_KEY,
  INSTANCES_QUERY_KEY,
  REVISION_PUBLISH_QUERY_KEY,
  REVISION_QUERY_KEY,
  REVISIONS_PUBLISH_URL,
  REVISIONS_QUERY_KEY,
  TODAY_MONITORING_QUERY_KEY
} from './queryConstants'

type UseRevisionPublishReturn = {
  publishRevision?: (args?: PublishRevisionArgs) => Promise<unknown>
  isPublishRevisionLoading?: boolean
}

type UseRevisionPublishProps = {
  id?: string
}

type PublishRevisionArgs = {
  sendEmail?: boolean
}

const useRevisionPublish = ({
  id
}: UseRevisionPublishProps): UseRevisionPublishReturn => {
  const queryClient = useQueryClient()

  // Publish event
  const publishFunction = async (
    args?: PublishRevisionArgs
  ): Promise<unknown> => {
    return postJSON({
      url: `${REVISIONS_PUBLISH_URL}/${id}`,
      method: 'POST',
      isRota: true,
      json: args
    })
  }

  const { mutateAsync: publishMutation, isLoading: isPublishRevisionLoading } =
    useMutation<unknown, unknown, PublishRevisionArgs | undefined>(
      [REVISION_PUBLISH_QUERY_KEY],
      publishFunction,
      {
        onSuccess: () => {
          queryClient.invalidateQueries([REVISIONS_QUERY_KEY])
          queryClient.invalidateQueries([REVISION_QUERY_KEY, id])
          queryClient.invalidateQueries([TODAY_MONITORING_QUERY_KEY])
          queryClient.invalidateQueries([INSTANCE_QUERY_KEY])
          queryClient.invalidateQueries([INSTANCES_QUERY_KEY])
        }
      }
    )

  const handlePublish = async (args?: PublishRevisionArgs) => {
    try {
      const result = await publishMutation(args)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    publishRevision: handlePublish,
    isPublishRevisionLoading
  }
}

export default useRevisionPublish
